<div class="text-center noData" style="width: auto; height: 100%">
    <img title="Keine aktuellen Daten vorhanden!" style="width: auto; height: 100%"
         [src]="environment.storageUrl + '/icons/cloud_off_black_18dp.png'"/>
</div>
